module.exports = __webpack_public_path__ + "img/benefit-title-desktop.918c06fc.png";